import React from 'react';

// import Swiper core and required modules
import { Navigation, Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/pagination';

import AVATAR from '../../assets/avatar.jfif';

import './Testimonials.css';

const data = [
	{
		avatar: AVATAR,
		name: 'Mohamed Tamer',
		review:
			'I built with Mahmoud the development of my company construction website, and the result was amazing! The site is not only attractive, but also easy to use. The experience was smooth working from start to finish. I am grateful for the efforts you put in and the very professionalism you demonstrated for the duration of the project'
	},
	{
		avatar: AVATAR,
		name: 'Ahmed Basem',
		review:
			'Thank you so much to Mahmoud for turning our vision into an amazing website. He had a unique ability to understand our needs and provide innovative solutions. Our website now represents a strong brand and provides a great user experience for our customers. The process of collaborating with him was very smooth and professional. We look forward to working with him on future projects'
	},
	{
		avatar: AVATAR,
		name: 'Ahmed Ali',
		review:
			'Mahmoud is a true professional in website development. He helped me launch a brand new website for my company, and the results were beyond amazing. The speed of implementation and the quality it provides are worthy of praise. He was always available to answer my questions and provide support when needed. I highly recommend him to anyone looking for a reliable and highly skilled website developer.'
	},
	{
		avatar: AVATAR,
		name: 'Mostafa Saad',
		review:
			'I commissioned Mahmoud to develop a new website for my company and I never imagined the result would be this amazing. Not only is the website beautiful and easy to navigate, it reflects the compan identity perfectly. I dealt with him throughout the project with confidence and professionalism, and he always provided innovative solutions that exceeded my expectations'
	}
];

const Testimonials = () => {
	return (
		<section id='testimonials'>
			<h5>Review from Clients</h5>
			<h2>Testimonials</h2>
			<Swiper
				className='container testimonials__container'
				// install Swiper modules
				modules={[Navigation, Pagination]}
				navigation
				spaceBetween={40}
				slidesPerView={1}
				pagination={{ clickable: true }}
			>
				{data.map(({ avatar, name, review }, index) => {
					return (
						<SwiperSlide key={index} className='testimonial'>
							<div className='client__avatar'>
								<img src={avatar} alt='Avatar-1' />
							</div>
							<h5 className='client__name'>{name}</h5>
							<small className='client__review'>{review}</small>
						</SwiperSlide>
					);
				})}
			</Swiper>
		</section>
	);
};

export default Testimonials;
